"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AIPricing = void 0;
var AIPricing;
(function (AIPricing) {
  AIPricing.PRESCRIBER_PRIORITY = ['M', 'N', 'D', 'RP'];
  ;
})(AIPricing || (exports.AIPricing = AIPricing = {}));
